import { correcao_de_fluxo } from "./correcao-de-fluxo/correcao-de-fluxo";
import { educacao_especial } from "./educacao-especial/educacao-especial";
const fase_concluida = [...correcao_de_fluxo, ...educacao_especial];

export { fase_concluida };
